module.exports = __webpack_public_path__ + "static/media/gc-partenon.696fe5db.png";